export const MainRoutes = {
  root: "/",
  signup: "/signup",
  logout: "/logout",
};
export const NAV_ROUTES = {
  dashboard: "/dashboard",
  transaction: "/transaction",
  wallet: "/wallet",
  notifications: "/notifications",
  profile: "/profile",
  support: "/support",
  setting: "/setting",
  SIGNUP_PASSWORD: "/confirm-password",
  forgot_Password: "/reset-password",
  set_Password: "/set-password",
};

export const ADMIN_ROUTES = {
  dashboard: "/admin/wallets",
  transaction: "/admin/transactions",
  users: "/admin/users",
  payment_methods: "/admin/payment-gateways",
  service_provider: "/admin/service-providers",
};
